import { render, staticRenderFns } from "./shops-footer.vue?vue&type=template&id=0b995e6e&scoped=true&"
import script from "./shops-footer.vue?vue&type=script&lang=js&"
export * from "./shops-footer.vue?vue&type=script&lang=js&"
import style0 from "./shops-footer.vue?vue&type=style&index=0&id=0b995e6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b995e6e",
  null
  
)

export default component.exports